<template>
  <v-card align="center" justify="center" light min-width="27vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title', { name: capitalize(channel.name) }) }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text v-if="contributors.length > 0" class="px-7 pt-1 pb-8">
      <v-container v-if="view === 'GENERAL'" fluid>
        <v-row align="center" class="mb-2">
          <v-col class="d-flex" cols="5">
            <h2>{{ $t('members') }}</h2>
            <v-btn class="ml-3 button-add" @click="addMemberView" small>{{ $t('btnAdd') }} <v-icon class="ml-2" color="white" small>fa-plus</v-icon></v-btn>
          </v-col>
          <v-col cols="7">
            <v-text-field :label="$t('searchLabel')" prepend-icon="fa-search" v-model="search"/>
          </v-col>
        </v-row>
        <v-data-table :items="contributors" :headers="headers" :search="search" hide-default-footer>
          <template v-slot:item.imageUrl="{ item }">
            <v-avatar size="37"><v-img :src="item.clubMember.user.imageUrl !== null? item.clubMember.user.imageUrl : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" contain></v-img></v-avatar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-chip class="ml-1" @click="removeContributorView(item)" small>{{ $t('table.btnRemove') }}</v-chip>
          </template>
        </v-data-table>
        <h4 v-if="contributors.length > 10" class="my-7">And {{ contributors.length - 10 }} more contributors</h4>
      </v-container>
      <v-container class="mt-5" v-else-if="view === 'ADD'" fluid>
        <v-row justify="center">
          <p class="text-center">{{ $t('add.message') }}</p>
        </v-row>
        <v-row>
          <v-autocomplete :label="$t('add.label')" :items="this.$store.state.clubMembers.filter((member) => member.rol !== 'PENDING')" @change="verifyUserNotJoined" item-text="user.email" item-value="id" v-model="memberIdToAdd" outlined/>
        </v-row>
        <v-row align="center" justify="center">
          <v-btn @click="view = 'GENERAL'">« {{ $t('btnAllMembers') }}</v-btn>
          <v-btn :disabled="memberIdToAdd === 0" class="ml-3" @click="addContributor">{{ $t('btnAddMember') }}</v-btn>
        </v-row>
      </v-container>
      <v-container class="mt-5" v-else fluid>
        <v-row justify="center">
          <v-avatar size="70">
            <v-img :src="currentContributor.clubMember.user.imageUrl !== null? currentContributor.clubMember.user.imageUrl : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" contain></v-img>
          </v-avatar>
        </v-row>
        <v-row align="center" justify="center">
          <p class="text-center mt-3"
             v-html="$t('remove.message', { user: currentContributor.clubMember.user.firstName, channel: capitalize(channel.name) })"/>
        </v-row>
        <v-row align="center" justify="center">
          <v-btn @click="view = 'GENERAL'">« {{ $t('btnAllMembers') }}</v-btn>
          <v-btn class="ml-3 remove-button" @click="removeContributor">{{ $t('btnRemove') }}</v-btn>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-text v-else class="px-7 pt-1 pb-8">
      <v-container v-if="view === 'GENERAL'" fluid>
        <h3 class="my-6">{{ $t('noMembers', { name: capitalize(channel.name)}) }} <v-icon class="ml-2 mt-n1">fa-grin-beam-sweat</v-icon></h3>
        <v-btn class="button-add" @click="addMemberView">{{ $t('btnAddFirstMember') }} <v-icon class="ml-2" color="white" small>fa-plus</v-icon></v-btn>
      </v-container>
      <v-container class="mt-5" v-else-if="view === 'ADD'" fluid>
        <v-row justify="center">
          <p class="text-center">{{ $t('add.message') }}</p>
        </v-row>
        <v-row>
          <v-autocomplete :label="$t('add.label')" :items="this.$store.state.clubMembers.filter((member) => member.rol !== 'PENDING')" @change="verifyUserNotJoined" item-text="user.email" item-value="id" v-model="memberIdToAdd" outlined/>
        </v-row>
        <v-row align="center" justify="center">
          <v-btn @click="view = 'GENERAL'">« {{ $t('btnAllMembers') }}</v-btn>
          <v-btn :disabled="memberIdToAdd === 0" class="ml-3" @click="addContributor">{{ $t('btnAddMember') }}</v-btn>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "ChannelContributors",
  props: {
    channel: Object,
  },
  data() {
    return {
      view: 'GENERAL',
      currentContributor: null,
      memberIdToAdd: 0,
      search: '',
      contributors: [],
      headers: [
        {text: this.$t('table.profile'), value: 'imageUrl', align: 'left', sortable: false, filterable: false},
        {text: this.$t('table.firstName'), value: 'clubMember.user.firstName', align: 'left', sortable: true, filterable: true},
        {text: this.$t('table.lastName'), value: 'clubMember.user.lastName', align: 'left', sortable: true, filterable: true},
        {text: this.$t('table.username'), value: 'clubMember.user.login', align: 'left', sortable: true, filterable: true},
        {text: this.$t('table.actions'), value: 'actions', align: 'right', sortable: false, filterable: false},
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      Repository.getAllClubChannelContributors(this.channel.id).then((response) => {
        if(response.status < 400)
          this.contributors = response.data;
      });
    },
    ...mapMutations(['setClubChannelsContributedByMe']),
    refreshMyChannelContributions() {
      Repository.getAllClubChannelsByContributor(this.$store.state.clubMember.id).then((response) => {
        if(response.status < 400)
          this.setClubChannelsContributedByMe(response.data);
      });
    },
    addMemberView() {
      this.view = 'ADD';
    },
    removeContributorView(contributor) {
      this.currentContributor = contributor;
      this.view = 'REMOVE';
    },
    verifyUserNotJoined() {
      if(this.contributors.find((contributor) => contributor.clubMember.id === this.memberIdToAdd) !== undefined) {
        alert(this.$t('add.already'));
        this.memberIdToAdd = 0;
      }
    },
    addContributor() {
      let clubChannelContributor = {
        clubChannel: { id: this.channel.id },
        clubMember: { id: this.memberIdToAdd },
      };

      Repository.joinClubChannelContributor(clubChannelContributor).then((response) => {
        if(response.status < 400) {
          alert(this.$t('add.alert', { name: this.capitalize(this.channel.name) }));
          this.init();
          if(this.memberIdToAdd === this.$store.state.clubMember.id)
            this.refreshMyChannelContributions();
          this.view = 'GENERAL';
        }
        else
          alert('An error occurred.');
      });
    },
    ...mapMutations(['resetCurrentClubChannel']),
    removeContributor() {
      Repository.deleteClubChannelContributor(this.currentContributor.id).then((response) => {
        if(response.status < 400) {
          alert(this.$t('remove.alert', { name: this.capitalize(this.channel.name) }));
          this.init();
          if(this.currentContributor.clubMember.id === this.$store.state.clubMember.id) {
            this.refreshMyChannelContributions();
            if(this.$store.state.currentClubChannel.id === this.currentContributor.clubChannel.id)
              this.resetCurrentClubChannel();
          }
          this.view = 'GENERAL';
        }
        else
          alert('An error occurred.');
      });
    },
    capitalize(string){
      return string[0] + string.slice(1).toLowerCase();
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<i18n>
{
  "en": {
    "title": "{name} Members",
    "members": "Members",
    "btnAdd": "Add",
    "table": {
      "profile": "Profile",
      "firstName": "First Name",
      "lastName": "Last Name",
      "username": "Username",
      "actions": "Actions",
      "btnRemove": "Remove Member"
    },
    "add": {
      "message": "Find existing users in the club by email",
      "label": "Search by email",
      "alert": "User was successfully joined to {name}!",
      "already": "User is already on the channel."
    },
    "remove": {
      "message": "You will remove {user} from {channel}.<br>This action can not be undone.",
      "alert": "User was successfully removed from {name}!"
    },
    "searchLabel": "Search by name or username",
    "btnAllMembers": "All Members",
    "btnAddMember": "Add Members",
    "btnAddFirstMember": "Add First Members",
    "btnRemove": "Yes, Remove Member",
    "noMembers": "There are no members in {name}"
  },
  "es": {
    "title": "Miembros de {name}",
    "members": "Miembros",
    "btnAdd": "Agregar",
    "table": {
      "profile": "Perfil",
      "firstName": "Nombres",
      "lastName": "Apellidos",
      "username": "Usuario",
      "actions": "Acciones",
      "btnRemove": "Eliminar Miembro"
    },
    "add": {
      "message": "Encontrar usuarios existentes en el club por su email",
      "label": "Buscar por email",
      "alert": "¡Usuario fue satisfactoriamente unido a {name}!",
      "already": "Ya se encuentra el usuario en el canal."
    },
    "remove": {
      "message": "Eliminarás a {user} del canal {channel}.<br>Esta acción no puede ser devuelta.",
      "alert": "¡Usuario fue satisfactoriamente eliminado del canal {name}!"
    },
    "searchLabel": "Buscar por nombre o usuario",
    "btnAllMembers": "Ir a Miembros",
    "btnAddMember": "Agregar Miembro",
    "btnAddFirstMember": "Agregar Primer Miembro",
    "btnRemove": "Sí, Eliminar Miembro",
    "noMembers": "No hay miembros en {name}"
  }
}
</i18n>

<style scoped>
  .button-add {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }

  .remove-button {
    background-color: #FF4747 !important;
    color: #FFFFFF !important;
    border: #FF4747 solid 2px !important;
  }

  .remove-button:hover {
    background-color: #FF4747 !important;
    color: #FFFFFF !important;
    border: #FF4747 solid 2px !important;
  }
</style>
